import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '../components/dashboard/Sidebar';
import CreatorHome from './creator/CreatorHome';
import CreatorSets from './creator/CreatorSets';
import CreatorProfile from './creator/CreatorProfile';
import SetEditor from './creator/SetEditor';
import ResidentHandbook from './creator/ResidentHandbook';

const CreatorDashboard = () => {
    return (
        <div className="flex min-h-screen bg-[#f8f8f8]">
            {/* Sidebar */}
            <Sidebar role="creator" />

            {/* Main Content Area */}
            <div className="flex-1 ml-64 p-8">
                <Routes>
                    <Route path="/" element={<CreatorHome />} />
                    <Route path="/handbook" element={<ResidentHandbook />} />
                    <Route path="/sets" element={<CreatorSets />} />
                    <Route path="/sets/new" element={<SetEditor />} />
                    <Route path="/sets/:id" element={<SetEditor />} />
                    <Route path="/profile" element={<CreatorProfile />} />
                </Routes>
            </div>
        </div>
    );
};

export default CreatorDashboard;
